"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultNavHeight = exports.setDefaultNavHeight = void 0;

var _sizes = require("HubStyleTokens/sizes");

var defaultNavHeight = null;

var setDefaultNavHeight = function setDefaultNavHeight(navHeight) {
  defaultNavHeight = navHeight;
};

exports.setDefaultNavHeight = setDefaultNavHeight;

var getDefaultNavHeight = function getDefaultNavHeight() {
  return defaultNavHeight || parseInt(_sizes.NAV_BAR_HEIGHT, 10);
};

exports.getDefaultNavHeight = getDefaultNavHeight;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/NavHeight.js
// module id = 695
// module chunks = 209 210 211 212